/*
 * Copyright (c) Schrocken Inc.
 * Author: Harish
 * File Description: Sign Up components
 */

import React from 'react';

import HeaderFooterwithCookies from '../../common/openPages/HeaderFooterwithCookies';

import AzureSignUp from './AzureSignUp';

function AzureSignUpIndex() {
  return (
    <HeaderFooterwithCookies cookiesEnabled>
      <AzureSignUp />
    </HeaderFooterwithCookies>
  );
}

export default AzureSignUpIndex;
